import { config } from 'env_def';
import debounce from 'lodash/debounce';
import { api } from '@/api/api';
import { storeOps } from '@/api/store/api_store';
import { MailSettingKeys, reDefinedColorList, reDefinedColorListNew, free_upload_size_local, free_upload_total_size_local, free_smtp_max_send_mail_size_local, upload_size_local, upload_total_size_local, smtp_max_send_mail_size_local, } from '@/api/logical/mail';
import { apis, inWindow, getDingTalkSearchString } from '@/config';
import { ErrResult } from '@/api/errMap';
import { methodMap } from './mail_action_store_model';
import { ArrayMap } from '@/api/commonModel';
import { util } from '@/api/util';
import corpMailUtils from './corp_mail_utils';
import { updateTrackerAttributes } from '../../api_system/data_tracker/data_tracker_impl';
import { getSidRegexp } from '@/const';
const SHOULD_AUTO_READMAILKEY = 'shouldAutoReadMail';
const SHOULD_AUTO_READMAILSERVERKEY = 'mail.autoMarkRead';
const CLOUD_ATTACHMENT_50M_DOMAINS = ['tal.com', 'chinacomlink.com'];
const globalStoreConfig = { noneUserRelated: true };
class ActionStore {
    constructor() {
        this.otherMailConfigListElements = [];
        this.signatures = new ArrayMap(it => String(it.id));
        this.mailConf = {};
        this.tagsUpdated = false;
        this.lastAttrSyncTime = 0;
        this.shouldAutoReadMail = true;
    }
}
const IMG_BOTTOM_ALIGN_WHITE_LIST = ['xdf.cn'];
class MailConfApiImpl {
    constructor() {
        this.sidRegexp = getSidRegexp();
        this.tagList = [];
        this.tagNameMap = {};
        this.tagBgMap = {};
        this.tagNameFontColorMap = {};
        this.seenFilterAccountMap = {};
        this.name = apis.mailConfApiImpl;
        this.systemApi = api.getSystemApi();
        this.httpApi = api.getDataTransApi();
        this.storeApi = api.getDataStoreApi();
        this.eventApi = api.getEventApi();
        this.htmlApi = api.requireLogicalApi(apis.htmlApi);
        this.mailApi = api.requireLogicalApi(apis.mailApiImpl);
        this.accountApi = api.requireLogicalApi(apis.accountApiImpl);
        this.action = new ActionStore();
        this.subAccountAction = new Map();
        this.dataTracker = api.requireLogicalApi(apis.dataTrackerApiImp);
        this.productAuthApi = api.requireLogicalApi(apis.productAuthApiImpl);
        this.debouncedDoGetUserAttr = debounce(this.doGetUserAttr.bind(this), 5000, { leading: true, trailing: false });
        this.defaultSignature = {
            content: '',
            id: 0,
            isDefault: false,
            isHtml: false,
            name: '',
            enable: true,
        };
        this.accountTokens = [];
        this.accountTokensTimer = null;
    }
    async getAccountBanSetting(account) {
        var _a;
        const res = { ban_del_mail: false, ban_export_mail: false, ban_del_contact: false, ban_legacy_attach_preview: false, ban_download_attach_pc: false };
        const noCache = this.systemApi.isNetworkAvailable();
        try {
            if (noCache) {
                const url = this.systemApi.getUrl('getBanSetting');
                const resData = await this.httpApi.post(url, undefined, { _account: account }).then(_res => _res.data);
                const resCode = resData === null || resData === void 0 ? void 0 : resData.code;
                if (resCode && [200, '200'].includes(resCode)) {
                    const resResult = (_a = resData.result) === null || _a === void 0 ? void 0 : _a.data;
                    res.ban_del_mail = (resResult === null || resResult === void 0 ? void 0 : resResult.ban_del_mail) || false;
                    res.ban_del_contact = (resResult === null || resResult === void 0 ? void 0 : resResult.ban_del_contact) || false;
                    res.ban_export_mail = (resResult === null || resResult === void 0 ? void 0 : resResult.ban_export_mail) || false;
                    res.ban_legacy_attach_preview = (resResult === null || resResult === void 0 ? void 0 : resResult.ban_legacy_attach_preview) || false;
                    res.ban_download_attach_pc = (resResult === null || resResult === void 0 ? void 0 : resResult.ban_download_attach_pc) || false;
                }
                this.putLocalSettingValue(JSON.stringify(res), 'banSetting', undefined, { _account: account });
            }
            else {
                let storeData = this.getLocalSettingValue('banSetting', undefined, account);
                storeData = JSON.parse(storeData || '{}');
                res.ban_del_mail = (storeData === null || storeData === void 0 ? void 0 : storeData.ban_del_mail) || false;
                res.ban_del_contact = (storeData === null || storeData === void 0 ? void 0 : storeData.ban_del_contact) || false;
                res.ban_export_mail = (storeData === null || storeData === void 0 ? void 0 : storeData.ban_export_mail) || false;
                res.ban_legacy_attach_preview = (storeData === null || storeData === void 0 ? void 0 : storeData.ban_legacy_attach_preview) || false;
                res.ban_download_attach_pc = (storeData === null || storeData === void 0 ? void 0 : storeData.ban_download_attach_pc) || false;
            }
        }
        catch (error) {
            console.error('[contact] getAccountBanSetting error', error);
        }
        return res;
    }
    getAutoAddContactAfterForwardConf(account) {
        const storeData = this.getLocalSettingValue(MailSettingKeys.nAutoAddMailContactAftForward, undefined, account);
        return (storeData && storeData === '1') || false;
    }
    getAutoAddContactAfterReplyConf(account) {
        const storeData = this.getLocalSettingValue(MailSettingKeys.nAutoAddMailContactAftReply, undefined, account);
        return (storeData && storeData === '1') || false;
    }
    getShowReceiverSeenFilter(account) {
        const emailId = this.storeApi.getEmailIdByEmail(account || '');
        if (!emailId) {
            const storeData = this.getLocalSettingValue(MailSettingKeys.openSentMailSeenFilter, 'false', account);
            return !!(storeData && storeData.toString() === 'true');
        }
        return !!(this.seenFilterAccountMap[account] && this.seenFilterAccountMap[account] === 'true');
    }
    setAutoAddContactAfterForwardConf(isAdd, account) {
        this.putLocalSettingValue(isAdd ? '1' : '0', MailSettingKeys.nAutoAddMailContactAftForward, undefined, { _account: account });
    }
    setAutoAddContactAfterReplyConf(isAdd, account) {
        this.putLocalSettingValue(isAdd ? '1' : '0', MailSettingKeys.nAutoAddMailContactAftReply, undefined, { _account: account });
    }
    async getAccountToken(_account) {
        try {
            const url = this.systemApi.getUrl('accountGetToken');
            const resData = await this.httpApi.post(url, undefined, { _account, headers: { 'Qiye-Header': 'sirius' } }).then(res => res.data);
            if ((resData === null || resData === void 0 ? void 0 : resData.code) && [200, '200'].includes(resData === null || resData === void 0 ? void 0 : resData.code)) {
                return resData.result.token;
            }
            return Promise.reject(JSON.stringify(resData));
        }
        catch (e) {
            return Promise.reject(e);
        }
    }
    async updateAccountTokens(payload) {
        if (process.env.BUILD_ISELECTRON)
            return [];
        const { accountsParam = [], forceUpdate } = payload;
        let accounts = accountsParam;
        let isUpdateAll = false;
        if (!accountsParam || !accountsParam.length) {
            const subAccounts = this.storeApi.getSubAccountList() || [];
            accounts = subAccounts.map(subAccount => subAccount.email);
            isUpdateAll = true;
        }
        if (isUpdateAll && this.accountTokensTimer) {
            clearTimeout(this.accountTokensTimer);
            this.accountTokensTimer = null;
        }
        await Promise.all(accounts.map(async (account) => {
            try {
                const tokenObj = this.accountTokens.find(item => item.account === account);
                const nowDate = new Date().getTime();
                let updateDate = null;
                if (tokenObj)
                    updateDate = tokenObj.updateDate;
                if (!updateDate || nowDate - updateDate > 1000 * 60 * 8 || forceUpdate) {
                    const res = await this.getAccountToken(account);
                    const newTokenInfo = {
                        account,
                        token: res,
                        updateDate: new Date().getTime(),
                    };
                    this.updateAccountToken(newTokenInfo);
                }
            }
            catch (ex) {
                return Promise.resolve();
            }
        }));
        if (isUpdateAll && !this.accountTokensTimer) {
            this.accountTokensTimer = setTimeout(() => {
                this.updateAccountTokens({});
            }, 1000 * 60 * 20);
        }
        return this.accountTokens;
    }
    updateAccountToken(tokenInfo) {
        if (!tokenInfo || !tokenInfo.account)
            return;
        const existInfo = this.accountTokens.find(item => item.account === tokenInfo.account);
        if (existInfo) {
            existInfo.token = tokenInfo.token;
            existInfo.updateDate = tokenInfo.updateDate;
        }
        else {
            this.accountTokens.push(tokenInfo);
        }
    }
    getTimezone() {
        if (!Number.isNaN(Number(this.action.mailConf[MailSettingKeys.nTimezone]))) {
            return Number(this.action.mailConf[MailSettingKeys.nTimezone]);
        }
        this.loadConfFromServer();
        return 8;
    }
    setTimezone(timezone) {
        const key = MailSettingKeys.nTimezone;
        return this.doSetUserAttr({
            [key]: timezone > 0 ? `+${timezone}` : `${timezone}`,
        });
    }
    getLocalTimezone() {
        const useLocalTimeZone = this.action.mailConf[MailSettingKeys.nLocalTimezone];
        return !!(useLocalTimeZone === null || useLocalTimeZone === '' || useLocalTimeZone === 'true' || useLocalTimeZone) || false;
    }
    setLocalTimezone(timezone) {
        const key = MailSettingKeys.nLocalTimezone;
        const attrs = {
            [key]: timezone,
        };
        return this.httpApi
            .post(this.buildUrl('setAttr'), {
            attrs,
        }, {
            contentType: 'json',
            useCacheResultPeriod: 600000,
            cachePolicy: 'refresh',
        })
            .then(this.unpackData.bind(this))
            .then((res) => {
            console.log('doSetUserAttr', res);
            if (res.code === MailConfApiImpl.sOk) {
                return true;
            }
            return false;
        })
            .catch(reason => {
            console.warn(reason);
            return false;
        });
    }
    async setMailBlackList(params) {
        const { blackList, whiteList } = params || {};
        const blackListKey = MailSettingKeys.nRefuseList;
        const whiteListKey = MailSettingKeys.nSaveList;
        const attrs = {
            [blackListKey]: blackList ? blackList.join(',') : undefined,
            [whiteListKey]: whiteList ? whiteList.join(',') : undefined,
        };
        return this.httpApi
            .post(this.buildUrl('setAttr'), {
            attrs,
        }, {
            contentType: 'json',
            useCacheResultPeriod: 600000,
            cachePolicy: 'refresh',
        })
            .then(this.unpackData.bind(this))
            .then((res) => {
            console.log('doSetUserAttr', res);
            if (res.code === MailConfApiImpl.sOk) {
                return res;
            }
            return Promise.reject(res);
        })
            .catch(reason => {
            console.warn(reason);
            return Promise.reject(reason);
        });
    }
    async setMailDefaultEncoding(key) {
        const EcodingKey = MailSettingKeys.nForward;
        const attrs = {
            [EcodingKey]: key,
        };
        return this.httpApi
            .post(this.buildUrl('setAttr'), {
            attrs,
        }, {
            contentType: 'json',
            useCacheResultPeriod: 600000,
            cachePolicy: 'refresh',
        })
            .then(this.unpackData.bind(this))
            .then((res) => {
            console.log('doSetUserAttr', res);
            if (res.code === MailConfApiImpl.sOk) {
                return true;
            }
            return Promise.reject(res);
        })
            .catch(reason => {
            console.warn(reason);
            return false;
        });
    }
    async getMailSenderInfo(_account) {
        const url = this.systemApi.getUrl('getMailSenderInfo');
        const isCorpMail = this.systemApi.getIsCorpMailMode();
        let _defaultSender;
        if (!isCorpMail) {
            _defaultSender = await this.getDefaultSendingAccount(_account);
        }
        const sid = this.getSid(_account);
        return this.httpApi
            .get(url, { sid }, { _account })
            .then(res => {
            const isCorpMail = this.systemApi.getIsCorpMailMode();
            if (isCorpMail) {
                corpMailUtils.corpMailTransformResponse(res);
            }
            const data = res.data;
            return data;
        })
            .then(async (res) => {
            var _a;
            const { aliasList = [], domainList = [], popAccountList = [], accountName = '', email = '', nickName = '', senderName = '', defaultSender, } = res.data || {};
            const mailEmail = email;
            const defaultAliasList = !aliasList
                ? []
                : aliasList.map(alias => {
                    var _a, _b;
                    return ({
                        id: alias === null || alias === void 0 ? void 0 : alias.email,
                        name: ((_a = alias === null || alias === void 0 ? void 0 : alias.email) === null || _a === void 0 ? void 0 : _a.split('@')[0]) || '',
                        domain: ((_b = alias === null || alias === void 0 ? void 0 : alias.email) === null || _b === void 0 ? void 0 : _b.split('@')[1]) || '',
                        nickName: alias === null || alias === void 0 ? void 0 : alias.nickName,
                        senderName: alias === null || alias === void 0 ? void 0 : alias.senderName,
                        mailEmail,
                        isMainEmail: (alias === null || alias === void 0 ? void 0 : alias.email) === email,
                        isDefault: (alias === null || alias === void 0 ? void 0 : alias.email) === (defaultSender === null || defaultSender === void 0 ? void 0 : defaultSender.email),
                    });
                });
            const domainAliasList = !domainList
                ? []
                : domainList
                    .map(domain => ({
                    id: `${accountName}@${domain}`,
                    name: accountName || nickName,
                    domain,
                    senderName,
                    mailEmail,
                    isMainEmail: `${accountName}@${domain}` === email,
                    isDefault: (defaultSender === null || defaultSender === void 0 ? void 0 : defaultSender.email) === `${accountName}@${domain}`,
                    nickName,
                }));
            const popoAliasList = !popAccountList
                ? []
                :
                    (_a = popAccountList === null || popAccountList === void 0 ? void 0 : popAccountList.filter(({ delegatedSend }) => !!delegatedSend)) === null || _a === void 0 ? void 0 : _a.map(({ id, email, nickName, senderName = '' }) => ({
                        id: email,
                        editId: id,
                        name: nickName,
                        domain: email === null || email === void 0 ? void 0 : email.split('@')[1],
                        isProxy: true,
                        nickName,
                        senderName,
                        mailEmail,
                        isMainEmail: false,
                        isDefault: email === _defaultSender,
                    }));
            const _result = [...defaultAliasList, ...domainAliasList, ...popoAliasList];
            const result = _result
                .sort((a, b) => a.isDefault ? -1 : b.isDefault ? 1 : 0)
                .reduce((acc, item) => {
                if (acc.some(_item => _item.id === item.id)) {
                    return acc;
                }
                return [...acc, item];
            }, []);
            if (isCorpMail) {
                const currentUser = this.systemApi.getCurrentUser();
                const hasMainAccount = !!result.find(item => item.id === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id));
                if (!hasMainAccount) {
                    result.push({
                        nickName: (currentUser === null || currentUser === void 0 ? void 0 : currentUser.nickName) || (currentUser === null || currentUser === void 0 ? void 0 : currentUser.accountName) || accountName,
                        name: accountName,
                        id: currentUser === null || currentUser === void 0 ? void 0 : currentUser.id,
                        domain: currentUser === null || currentUser === void 0 ? void 0 : currentUser.domain,
                    });
                }
            }
            this.storeApi.setUserProp('accountAlias', result.filter(info => !info.isProxy).map(info => info.id), true, _account);
            return result;
        })
            .catch(err => {
            console.error(err);
            return [];
        });
    }
    doGetOriginAccount() {
        return this.action.mailConf[MailSettingKeys.nOriginalAccount];
    }
    setMailPageLayout(value) {
        const key = MailSettingKeys.nBannerLayout;
        this.putLocalSettingValue(value, key);
        this.setMailConfig();
    }
    getMailPageLayout() {
        const key = MailSettingKeys.nBannerLayout;
        const defaultVal = '2';
        const res = this.getLocalSettingValue(key, defaultVal);
        if (res) {
            if (res === 'true') {
                return '1';
            }
            if (res === 'false') {
                return '2';
            }
            return this.getLocalSettingValue(key);
        }
        return defaultVal;
    }
    async getIsFreeMailByCosId() {
        const defaultValue = false;
        try {
            await this.loadConfFromServer();
            const key = MailSettingKeys.nCosId;
            const res = this.getLocalSettingValue(key);
            if (res && res.toString() === '999') {
                return true;
            }
            return defaultValue;
        }
        catch (ex) {
            console.error('getIsFreeMailByCosId-error', ex);
            return defaultValue;
        }
    }
    setMailShowDesc(value) {
        const key = MailSettingKeys.nShowDesc;
        this.putLocalSettingValue(value, key);
        this.setMailConfig();
    }
    getMailShowDesc() {
        const key = MailSettingKeys.nShowDesc;
        if (key in this.action.mailConf) {
            const ret = this.action.mailConf[key];
            return ret === 'true';
        }
        const sync = this.storeApi.getSync(key);
        const ret = sync && sync.data && sync.suc ? sync.data : 'true';
        this.action.mailConf[key] = ret;
        return ret === 'true';
    }
    setMailShowAttachment(value) {
        const key = MailSettingKeys.nShowAttachment;
        this.putLocalSettingValue(value, key);
        this.setMailConfig();
    }
    getMailShowAttachment() {
        const key = MailSettingKeys.nShowAttachment;
        if (key in this.action.mailConf) {
            const ret = this.action.mailConf[key];
            return ret === 'true';
        }
        const sync = this.storeApi.getSync(key);
        const ret = sync && sync.data && sync.suc ? sync.data : 'true';
        this.action.mailConf[key] = ret;
        return ret === 'true';
    }
    setMailShowAvator(value) {
        const key = MailSettingKeys.nShowAvator;
        this.putLocalSettingValue(value, key);
        this.setMailConfig();
    }
    getMailShowAvator() {
        const key = MailSettingKeys.nShowAvator;
        if (key in this.action.mailConf) {
            const ret = this.action.mailConf[key];
            return ret === 'true';
        }
        const sync = this.storeApi.getSync(key);
        const ret = sync && sync.data && sync.suc ? sync.data : 'true';
        this.action.mailConf[key] = ret;
        return ret === 'true';
    }
    setShowConcreteTime(value) {
        const key = MailSettingKeys.nShowConcreteTime;
        this.putLocalSettingValue(value, key);
        this.setMailConfig();
    }
    getShowConcreteTime() {
        const key = MailSettingKeys.nShowConcreteTime;
        if (key in this.action.mailConf) {
            const ret = this.action.mailConf[key];
            return ret === 'true';
        }
        const sync = this.storeApi.getSync(key);
        const ret = sync && sync.data && sync.suc ? sync.data : 'true';
        this.action.mailConf[key] = ret;
        return ret === 'true';
    }
    setShowCustomerTab(value) {
        const key = MailSettingKeys.nMailListShowCustomerTab;
        this.putLocalSettingValue(value, key);
    }
    getShowCustomerTab() {
        const key = MailSettingKeys.nMailListShowCustomerTab;
        if (key in this.action.mailConf) {
            const ret = this.action.mailConf[key];
            return ret === 'true';
        }
        const sync = this.storeApi.getSync(key);
        const ret = sync && sync.data && sync.suc ? sync.data : 'true';
        this.action.mailConf[key] = ret;
        return ret === 'true';
    }
    setShowCustomerCompany(value) {
        const key = MailSettingKeys.nShowCustomerCompany;
        this.putLocalSettingValue(value, key);
        this.setMailConfig();
    }
    getShowCustomerCompany() {
        const key = MailSettingKeys.nShowCustomerCompany;
        if (key in this.action.mailConf) {
            const ret = this.action.mailConf[key];
            return ret === 'true';
        }
        const sync = this.storeApi.getSync(key);
        const ret = sync && sync.data && sync.suc ? sync.data : 'true';
        this.action.mailConf[key] = ret;
        return ret === 'true';
    }
    setMailListTightness(value) {
        const key = MailSettingKeys.nMailListTightness;
        this.action.mailConf[key] = String(value);
        this.storeApi.putSync(key, String(value));
        if (+value !== 3) {
            this.setMailConfig();
        }
    }
    getMailListTightness() {
        const key = MailSettingKeys.nMailListTightness;
        return this.getLocalSettingValue(key, '2');
    }
    getIsUseRealListKey() {
        return process.env.BUILD_ISELECTRON ? 'DISPLAY_PAGING_DESKTOP' : 'DISPLAY_PAGING_WEB';
    }
    getIsUseRealListOtherKey() {
        return process.env.BUILD_ISELECTRON ? 'DISPLAY_PAGING_WEB' : 'DISPLAY_PAGING_DESKTOP';
    }
    async getMailConfig() {
        const result = this.mailApi
            .getMailConfig()
            .then(res => {
            if (res.available) {
                const set = Object.assign({}, res);
                if (set.displayMode) {
                    const value = Boolean(set.displayMode === 'TOPIC_AGG');
                    const isMerge = this.getMailMergeSettings() === 'true';
                    if (value !== isMerge) {
                        this.setMailMergeSettings(value, true);
                    }
                }
                if (set.mailView) {
                    const key = MailSettingKeys.nBannerLayout;
                    const jsonView = { SUB_FIELD: '1', FULL_FIELD: '2', UP_DOWN_FIELD: '3' };
                    this.putLocalSettingValue(jsonView[set.mailView], key);
                    this.action.mailConf[key] = jsonView[set.mailView];
                }
                if (set.listSpace) {
                    const json = { LOOSE: 1, SUITABLE: 2, COMPACT: 3 };
                    const key = MailSettingKeys.nMailListTightness;
                    const value = json[set.listSpace];
                    this.action.mailConf[key] = String(value);
                    this.storeApi.putSync(key, String(value));
                }
                if (Array.isArray(set.listElements)) {
                    const key = MailSettingKeys.nShowDesc;
                    this.putLocalSettingValue(set.listElements.includes('ABSTRACT'), key);
                    const key1 = MailSettingKeys.nShowAttachment;
                    this.putLocalSettingValue(set.listElements.includes('ATTACH_DETAIL'), key1);
                    const key2 = MailSettingKeys.nShowAvator;
                    this.putLocalSettingValue(set.listElements.includes('SENDER_ICON'), key2);
                    const key3 = MailSettingKeys.nShowConcreteTime;
                    this.putLocalSettingValue(set.listElements.includes('DISPLAY_MAIL_SEND_TIME'), key3);
                    const key4 = MailSettingKeys.nShowCustomerCompany;
                    this.putLocalSettingValue(!set.listElements.includes('CUSTOMER_COMPANY'), key4);
                    const useRealListKey = MailSettingKeys.nIsUseReaList;
                    const isUseRealList = set.listElements.includes(this.getIsUseRealListKey());
                    MailConfApiImpl.isUseRealList = isUseRealList;
                    this.putLocalSettingValue(isUseRealList, useRealListKey, undefined, this.getUseRealListStoreConfig());
                    const otherRealListKey = this.getIsUseRealListOtherKey();
                    const isOtherRealList = set.listElements.includes(otherRealListKey);
                    if (isOtherRealList) {
                        this.action.otherMailConfigListElements.push(otherRealListKey);
                    }
                }
            }
            else {
            }
            const sendRevoke = res.sendRevoke || 'OFF';
            const sendRevokeIn = res.sendRevokeIn || 15;
            this.storeApi.putSync('sendRevoke', sendRevoke);
            this.storeApi.putSync('sendRevokeIn', String(sendRevokeIn));
            return res.available;
        })
            .catch(() => false);
        return result;
    }
    async setMailConfig() {
        const params = this.getQuickSettingParam();
        this.quickSettingTrack(params);
        return this.mailApi.setMailConfig(params);
    }
    getQuickSettingParam() {
        const key2 = MailSettingKeys.nBannerLayout;
        const key3 = MailSettingKeys.nMailListTightness;
        const key4 = MailSettingKeys.nShowDesc;
        const key5 = MailSettingKeys.nShowAttachment;
        const key6 = MailSettingKeys.nShowAvator;
        const key7 = MailSettingKeys.nShowConcreteTime;
        const key8 = MailSettingKeys.nShowCustomerCompany;
        const isUseRealListKey = MailSettingKeys.nIsUseReaList;
        const displayMode = this.getMailMergeSettings() === 'true' ? 'TOPIC_AGG' : 'NORMAL';
        const jsonView = { 1: 'SUB_FIELD', 2: 'FULL_FIELD', 3: 'UP_DOWN_FIELD' };
        const mailView = jsonView[this.getLocalSettingValue(key2)] || 2;
        const json = { 1: 'LOOSE', 2: 'SUITABLE', 3: 'COMPACT' };
        const listSpace = json[this.getLocalSettingValue(key3, '2')];
        const listElements = [];
        if (this.getLocalSettingValue(key4, 'true') === 'true') {
            listElements.push('ABSTRACT');
        }
        if (this.getLocalSettingValue(key5, 'true') === 'true') {
            listElements.push('ATTACH_DETAIL');
        }
        if (this.getLocalSettingValue(key6, 'true') === 'true') {
            listElements.push('SENDER_ICON');
        }
        if (this.getLocalSettingValue(isUseRealListKey, 'false', undefined, this.getUseRealListStoreConfig()) === 'true') {
            listElements.push(this.getIsUseRealListKey());
        }
        if (this.getLocalSettingValue(key7, 'false') === 'true') {
            listElements.push('DISPLAY_MAIL_SEND_TIME');
        }
        if (this.getLocalSettingValue(key8, 'false') !== 'true') {
            listElements.push('CUSTOMER_COMPANY');
        }
        if (this.action && this.action.otherMailConfigListElements && this.action.otherMailConfigListElements.length) {
            const otherListElementKeys = this.action.otherMailConfigListElements.filter(item => !listElements.includes(item));
            if (otherListElementKeys && otherListElementKeys.length) {
                listElements.push(...otherListElementKeys);
            }
        }
        let sendRevoke = this.storeApi.getSync('sendRevoke').data;
        sendRevoke = sendRevoke && ['ON', 'OFF'].includes(sendRevoke) ? sendRevoke : 'OFF';
        let sendRevokeIn = Number(this.storeApi.getSync('sendRevokeIn').data);
        sendRevokeIn = sendRevokeIn && [5, 10, 15, 30, 60].includes(sendRevokeIn) ? sendRevokeIn : 0;
        const params = {
            displayMode,
            mailView,
            listSpace,
            listElements,
            sendRevoke,
            sendRevokeIn,
        };
        return params;
    }
    quickSettingTrack(param, isNull) {
        const { displayMode, mailView, listSpace, listElements } = param || {};
        let json = {};
        if (isNull) {
            json = {
                thread: null,
                layout: null,
                space: null,
                showDigest: null,
                showAttachment: null,
                showHeadPortrait: null,
                showCustomerCompany: null,
            };
        }
        else {
            const tightnessObj = {
                LOOSE: '宽松',
                SUITABLE: '适中',
                COMPACT: '紧凑',
            };
            const layoutJson = { SUB_FIELD: '左右分栏', FULL_FIELD: '通栏', UP_DOWN_FIELD: '上下分栏' };
            json = {
                thread: displayMode === 'TOPIC_AGG' ? '按主题聚合' : '普通模式',
                layout: mailView ? layoutJson[mailView] : '通栏',
                space: (listSpace && tightnessObj[listSpace]) || '适中',
                showDigest: listElements && listElements.includes('ABSTRACT') ? 'on' : 'off',
                showAttachment: listElements && listElements.includes('ATTACH_DETAIL') ? 'on' : 'off',
                showHeadPortrait: listElements && listElements.includes('SENDER_ICON') ? 'on' : 'off',
                showPagingDevice: listElements && listElements.includes(this.getIsUseRealListKey()) ? 'on' : 'off',
                showPointInTime: listElements && listElements.includes('DISPLAY_MAIL_SEND_TIME') ? 'on' : 'off',
                showCustomerCompany: listElements && listElements.includes('CUSTOMER_COMPANY') ? 'off' : 'on',
            };
        }
        this.dataTracker.track('pcMail_view_mailListPage', json);
    }
    doOpenRelatedPage(contact, fromAccount) {
        const mainEmail = this.systemApi.getMainAccount1().email;
        const sinceAccount = (fromAccount || mainEmail);
        const list = [];
        if (contact && contact.contactInfo && contact.contactInfo.length > 0) {
            contact.contactInfo.forEach(it => {
                if (it.contactItemType === 'EMAIL') {
                    list.push(it.contactItemVal);
                }
            });
            if (list.length > 0) {
                if (this.systemApi.isElectron()) {
                    this.systemApi.createWindowWithInitData('readMailComb', {
                        eventData: {
                            fromAccount: sinceAccount,
                            list,
                        },
                        eventName: 'initPage',
                    });
                }
                else {
                    this.systemApi.openNewWindow(MailConfApiImpl.contextPath + `/readMailComb/?${getDingTalkSearchString(false, true)}account=` + encodeURIComponent(sinceAccount) + `#${list.join(',')}`, false);
                }
            }
        }
    }
    doOpenEdmRelatedPage(params) {
        const { _account, customerId, selectedEmail, isSelf } = params;
        if (!customerId || !selectedEmail) {
            throw new Error('必须传入客户id以及客户联系人');
        }
        const mainEmail = this.systemApi.getMainAccount1().email;
        const account = _account || mainEmail;
        if (!isSelf) {
            const list = [selectedEmail];
            if (this.systemApi.isElectron()) {
                this.systemApi.createWindowWithInitData('readMailComb', {
                    eventData: {
                        fromAccount: account,
                        list,
                    },
                    eventName: 'initPage',
                });
            }
            else {
                this.systemApi.openNewWindow(MailConfApiImpl.contextPath + '/readMailComb/?account=' + encodeURIComponent(account) + `#${list.join(',')}`, false);
            }
            return;
        }
        if (this.systemApi.isElectron()) {
            this.systemApi.createWindowWithInitData('readMailComb', {
                eventData: {
                    fromAccount: _account,
                    customerId,
                    selectedEmail,
                },
                eventName: 'initPage',
            });
        }
        else {
            const search = `account=${account}&customerId=${customerId}&selectedEmail=${selectedEmail}`;
            this.systemApi.openNewWindow(`${MailConfApiImpl.contextPath}/readMailComb/?${encodeURIComponent(search)}`, false);
        }
    }
    doOpenStrangerPage() {
        if (this.systemApi.isElectron()) {
            this.systemApi
                .createWindowWithInitData('strangerMails', {
                eventName: 'initPage',
            })
                .then();
        }
        else {
            this.systemApi.openNewWindow(MailConfApiImpl.contextPath + '/strangerMails/', false);
        }
    }
    setMailMergeSettings(value, notAsync) {
        const ev = {
            eventName: 'mailChanged',
            eventData: value,
            eventSeq: 0,
            eventStrData: 'mailMergeModelChange',
        };
        const key = MailSettingKeys.nShowMergedMail;
        this.putLocalSettingValue(value, key, ev);
        if (!notAsync) {
            this.setMailConfig();
        }
    }
    setMailAutoAddContact(enable) {
        const key = MailSettingKeys.nAutoAddMailContact;
        return this.doSetUserAttr({
            [key]: enable ? '1' : '0',
        });
    }
    setReplyForwardSetting(_value) {
        return this.doSetUserAttr({
            [MailSettingKeys.nForward]: _value,
            [MailSettingKeys.nReplay]: _value,
        });
    }
    async setBlackListOrWhiteList(email, block) {
        try {
            const white = MailSettingKeys.nSaveList;
            const black = MailSettingKeys.nRefuseList;
            const currentList = await this.doGetUserAttr([white, black]);
            const { refuselist = '', safelist = '' } = currentList;
            if (((refuselist === null || refuselist === void 0 ? void 0 : refuselist.includes(email)) && block) || ((safelist === null || safelist === void 0 ? void 0 : safelist.includes(email)) && !block)) {
                return 'exist';
            }
            let whiteList = [];
            let blackList = [];
            if (block) {
                blackList = refuselist.includes(email) ? refuselist.split(',') : [...refuselist.split(','), email];
                whiteList = safelist.split(',').filter(r => r !== email);
            }
            else {
                blackList = refuselist === null || refuselist === void 0 ? void 0 : refuselist.split(',').filter(r => r !== email);
                whiteList = whiteList.includes(email) ? safelist.split(',') : [...safelist.split(','), email];
            }
            return this.doSetUserAttr({
                [white]: whiteList.join(','),
                [black]: blackList.join(','),
            });
        }
        catch (error) {
            return false;
        }
    }
    putLocalSettingValue(value, key, ev, config) {
        const data = String(value);
        this.action.mailConf[key] = data;
        this.storeApi.put(key, data, config).then(() => {
            var _a;
            if (ev) {
                (_a = this.eventApi.sendSysEvent(ev)) === null || _a === void 0 ? void 0 : _a.catch(err => {
                    console.error(err);
                });
            }
            console.log('[mail-conf] setting value stored ' + key + '->' + value);
        });
    }
    getMailMergeSettings(_account) {
        const key = MailSettingKeys.nShowMergedMail;
        return this.getLocalSettingValue(key, _account);
    }
    async getMailAutoAddContact() {
        const defaultValue = '0';
        try {
            const key = MailSettingKeys.nAutoAddMailContact;
            if (this.action.mailConf && this.action.mailConf[key]) {
                return this.action.mailConf[key];
            }
            await this.loadConfFromServer();
            if (this.action.mailConf && this.action.mailConf[key]) {
                return this.action.mailConf[key];
            }
            return defaultValue;
        }
        catch (error) {
            return Promise.resolve(defaultValue);
        }
    }
    getPermRecallMail() {
        try {
            const key = MailSettingKeys.nPermRecallMail;
            const result = this.getLocalSettingValue(key);
            return typeof result === 'boolean' ? result : true;
        }
        catch (error) {
            return true;
        }
    }
    isDomainInWhiteList(domain) {
        const stage = config('stage');
        if (stage !== 'prod' || process.env.NODE_ENV !== 'production')
            return true;
        return !!domain && IMG_BOTTOM_ALIGN_WHITE_LIST.includes(domain);
    }
    canUseImgBottomAlign(_account) {
        var _a;
        try {
            const account = _account || ((_a = this.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '';
            const domain = (account === null || account === void 0 ? void 0 : account.split('@')[1]) || '';
            if (!this.isDomainInWhiteList(domain))
                return false;
            return this.getLocalSettingValue(MailSettingKeys.nImgBottomAlign, 'true', _account) !== 'false';
        }
        catch (error) {
            console.error('canUseImgBottomAlign-error', error);
            return false;
        }
    }
    setImgBottomAlign(enable) {
        this.putLocalSettingValue(enable, MailSettingKeys.nImgBottomAlign);
    }
    async getOriginAccountAsync() {
        try {
            await this.loadConfFromServer();
            const key = MailSettingKeys.nOriginalAccount;
            const result = this.getLocalSettingValue(key, '');
            return result;
        }
        catch (error) {
            return '';
        }
    }
    getLocalSettingValue(key, defaultVal = 'false', _account, storeConfig) {
        var _a;
        const action = (_a = this.systemApi.getActions({
            actions: this.action,
            subActions: this.subAccountAction,
            _account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        if (key in action.mailConf) {
            return action.mailConf[key];
        }
        const sync = this.storeApi.getSync(key, storeConfig ? Object.assign({ _account }, storeConfig) : { _account });
        const ret = sync && sync.data && sync.suc ? sync.data : defaultVal;
        action.mailConf[key] = ret;
        return ret;
    }
    async getFolderSettings(_account) {
        return this.getSettings(MailSettingKeys.nFolderSetting, _account);
    }
    async getSettings(key, _account) {
        var _a;
        const action = (_a = this.systemApi.getActions({
            actions: this.action,
            subActions: this.subAccountAction,
            _account,
        })) === null || _a === void 0 ? void 0 : _a.val;
        let mailConfElement = action === null || action === void 0 ? void 0 : action.mailConf[key];
        if (!mailConfElement) {
            await this.loadMailConf(_account);
            mailConfElement = action.mailConf[key];
        }
        return mailConfElement;
    }
    getReplayStyle(title) {
        return String(this.action.mailConf[MailSettingKeys.nReplay]) === '0' ? 'Re:' : '回复：';
    }
    getForwardStyle(title) {
        if (['Fw:', 'FW:', '转发:', 'Fw：', 'FW：', '转发：'].includes(title.substring(0, 3))) {
            return '';
        }
        return String(this.action.mailConf[MailSettingKeys.nReplay]) === '0' ? 'Fw:' : '转发：';
    }
    getConfigByNreplay() {
        return String(this.action.mailConf[MailSettingKeys.nReplay]) === '0' ? MailConfApiImpl.nReplayEnMap : MailConfApiImpl.nReplayChnMap;
    }
    isReplyHeaderEnglish() {
        return String(this.action.mailConf[MailSettingKeys.nReplay]) === '0';
    }
    async getDefaultSendingAccount(_account) {
        var _a, _b;
        let mailConfElement = (_a = this.systemApi.getActions({
            actions: this.action,
            subActions: this.subAccountAction,
            _account,
        }).val) === null || _a === void 0 ? void 0 : _a.mailConf[MailSettingKeys.nDefaultSendingAccount];
        if (!mailConfElement) {
            await this.loadConfFromServer(_account);
            mailConfElement = (_b = this.systemApi.getActions({
                actions: this.action,
                subActions: this.subAccountAction,
                _account,
            }).val) === null || _b === void 0 ? void 0 : _b.mailConf[MailSettingKeys.nDefaultSendingAccount];
        }
        return mailConfElement;
    }
    async loadConfFromServer(_account) {
        var _a, _b;
        const currentStore = this.systemApi.getActions({
            actions: this.action,
            subActions: this.subAccountAction,
            _account,
        });
        const { suc, val: currentAction } = currentStore;
        if (!suc)
            return;
        let isMain = true;
        if (!_account || _account === ((_a = this.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id)) {
            isMain = true;
        }
        else {
            isMain = false;
        }
        const stamp = Date.now();
        if (isMain && (currentAction === null || currentAction === void 0 ? void 0 : currentAction.lastAttrSyncTime) && stamp - currentAction.lastAttrSyncTime < 2 * 60 * 1000) {
            return Promise.resolve();
        }
        if (!isMain && (currentAction === null || currentAction === void 0 ? void 0 : currentAction.lastAttrSyncTime) && stamp - currentAction.lastAttrSyncTime < 60 * 60 * 1000) {
            return Promise.resolve();
        }
        const res = await this.debouncedDoGetUserAttr([
            MailSettingKeys.nForward,
            MailSettingKeys.nReplay,
            MailSettingKeys.nFolderSetting,
            MailSettingKeys.nAutoAddMailContact,
            MailSettingKeys.nDefaultSendingAccount,
            MailSettingKeys.nOriginalAccount,
            MailSettingKeys.nPermRecallMail,
            MailSettingKeys.nCosId,
            MailSettingKeys.nTimezone,
            MailSettingKeys.nLocalTimezone,
            MailSettingKeys.nUploadSize,
            MailSettingKeys.nSmtpMaxSendMailSize,
            MailSettingKeys.nOriginalAccount,
            MailSettingKeys.skipWmreplyAutoClassify,
            MailSettingKeys.skipWmotherreplyAutoClassify,
            MailSettingKeys.openSentMailSeenFilter,
        ], _account);
        if (res && res[MailSettingKeys.nFolderSetting] !== undefined && res[MailSettingKeys.nDefaultSendingAccount] !== undefined) {
            if (currentAction) {
                currentAction.mailConf = Object.assign(currentAction.mailConf, res);
                currentAction.lastAttrSyncTime = Date.now();
            }
            if (res[MailSettingKeys.nCosId] && isMain) {
                let mailVersionValue = res[MailSettingKeys.nCosId];
                if (process.env.BUILD_ISLINGHANG) {
                    const isNavigateVersion = (_b = this.systemApi.doGetProductInfo()) === null || _b === void 0 ? void 0 : _b.navigateVersion;
                    if (isNavigateVersion) {
                        mailVersionValue = -1;
                    }
                }
                updateTrackerAttributes({
                    mailVersion: mailVersionValue,
                });
            }
        }
        return res;
    }
    async loadMailConf(_account) {
        if (this.systemApi.getCurrentUser(_account)) {
            this.getMailMergeSettings(_account);
            try {
                await this.loadConfFromServer(_account);
                this.initData();
            }
            catch (e) {
                console.error(e);
            }
        }
    }
    buildUrl(key, additionalParam, _account) {
        const sid = this.getSid(_account);
        if (!sid) {
            return MailConfApiImpl.comNotExist;
        }
        const isCorpMailModeUser = this.systemApi.getIsCorpMailMode();
        if (isCorpMailModeUser) {
            const params = Object.assign({ sid }, (additionalParam || {}));
            const url = corpMailUtils.getUrlByMailFuncName(key);
            return this.httpApi.buildUrl(url, params);
        }
        let req = {
            func: methodMap[key],
            sid,
        };
        if (additionalParam) {
            req = Object.assign(req, additionalParam);
        }
        return this.httpApi.buildUrl(this.systemApi.getAccountUrl('mailOperation', _account), req);
    }
    unpackData(res) {
        console.log('[mail-conf] return from network:', res);
        const isCorpMail = this.systemApi.getIsCorpMailMode();
        if (isCorpMail) {
            corpMailUtils.corpMailTransformResponse(res);
        }
        const data = res.data;
        return data;
    }
    handleRiskHitInterrupt(resp) {
        var _a, _b, _c, _d;
        const data = resp.data;
        if ((data === null || data === void 0 ? void 0 : data.code) === ErrResult.FA_RISK_HIT_INTERRUPT.code) {
            this.eventApi.sendSysEvent({
                eventName: 'RiskHitInterrupt',
                eventData: {
                    code: data.code,
                    operate: (_a = data.operate) !== null && _a !== void 0 ? _a : (_b = data.data) === null || _b === void 0 ? void 0 : _b.operation,
                    url: (_c = data.url) !== null && _c !== void 0 ? _c : (_d = data.data) === null || _d === void 0 ? void 0 : _d.url,
                },
                _account: resp.config._account,
            });
        }
        return resp;
    }
    syncSubActions() {
        try {
            const subAccounts = this.storeApi.getSubAccountList();
            if ((subAccounts === null || subAccounts === void 0 ? void 0 : subAccounts.length) > 0) {
                subAccounts.forEach((subAccount) => this.createSubActions(subAccount.email));
            }
        }
        catch (error) {
            console.log('mailConfApi syncSubActions error', error);
        }
    }
    createSubActions(_account) {
        if (this.subAccountAction.has(_account)) {
            return { suc: true, msg: 'existed' };
        }
        this.subAccountAction.set(_account, new ActionStore());
        return { suc: true, msg: 'suc' };
    }
    async loadAccountSeenFilter(account) {
        const accountStr = account || '';
        if (this.seenFilterAccountMap[accountStr]) {
            return;
        }
        this.doGetUserAttr([MailSettingKeys.openSentMailSeenFilter], accountStr).then(res => {
            this.seenFilterAccountMap[accountStr] = (res[MailSettingKeys.openSentMailSeenFilter].toString() || 'false');
        });
    }
    initSubAccountMailConf(account) {
        if (!process.env.BUILD_ISEDM) {
            return;
        }
        if (!account) {
            return;
        }
        this.loadAccountSeenFilter(account);
    }
    initData() {
        console.log('initModule send account');
    }
    afterLoadFinish() {
        this.loadMailConf().then().catch(console.error);
        this.getMailConfig();
        this.getMailLimitFromServer();
        this.eventApi.registerSysEventObserver('SubAccountAdded', {
            name: 'SubAccountAdded-MailConfImpl',
            func: ev => {
                if (ev && ev.eventData) {
                    const { eventData } = ev;
                    const { subAccount } = eventData;
                    this.updateAccountTokens({ accountsParam: [subAccount], forceUpdate: true });
                    if (subAccount && !this.subAccountAction.has(subAccount)) {
                        this.subAccountAction.set(subAccount, new ActionStore());
                    }
                    this.initSubAccountMailConf(subAccount.email);
                }
            },
        });
        this.eventApi.registerSysEventObserver('SubAccountDeleted', {
            name: 'SubAccountDeleted-MailConfImpl',
            func: ev => {
                if (ev && ev.eventData) {
                    const { eventData } = ev;
                    const { subAccount } = eventData;
                    if (subAccount && this.subAccountAction.has(subAccount)) {
                        this.subAccountAction.delete(subAccount);
                    }
                }
            },
        });
        if (!process.env.BUILD_ISELECTRON) {
            this.eventApi.registerSysEventObserver('subAccountLogin', {
                name: 'subAccountLogin-MailConfImpl',
                func: ev => {
                    if (ev && ev.eventData) {
                        const { id: subAccount } = ev.eventData;
                        if (!subAccount)
                            return;
                        this.updateAccountTokens({ accountsParam: [subAccount], forceUpdate: true });
                    }
                },
            });
        }
        if (this.systemApi.isMainPage()) {
            this.getAccountBanSetting(undefined);
        }
        return this.name;
    }
    afterLogin() {
        this.action = new ActionStore();
        this.loadMailConf().then();
        this.getMailConfig();
        return this.name;
    }
    init() {
        this.updateShouldAutoReadMail();
        return this.name;
    }
    afterInit() {
        try {
            const subAccounts = this.storeApi.getSubAccountList();
            if ((subAccounts === null || subAccounts === void 0 ? void 0 : subAccounts.length) > 0) {
                subAccounts.forEach((subAccount) => {
                    this.createSubActions(subAccount.email);
                    this.initSubAccountMailConf(subAccount.email);
                });
            }
            setTimeout(() => {
                this.updateAccountTokens({});
            }, 10);
        }
        catch (error) {
            console.log('获取子账号并设置 error', error);
        }
        return this.name;
    }
    doGetUserAttr(attrs, _account) {
        return this.httpApi
            .post(this.buildUrl('getAttr', undefined, _account), { attrIds: attrs }, {
            contentType: 'json',
            useCacheResultPeriod: 600000,
            cachePolicy: 'refresh',
            _account,
        })
            .then(this.unpackData.bind(this))
            .then((res) => {
            if (res.code === MailConfApiImpl.sOk) {
                return res.var;
            }
            return {};
        })
            .catch(reason => {
            console.warn(reason);
            return {};
        });
    }
    async getReplyAutoClassifyConf() {
        var _a;
        const { skip_wmreply_auto_classify, skip_wmotherreply_auto_classify } = ((_a = this.action) === null || _a === void 0 ? void 0 : _a.mailConf) || {};
        if (skip_wmreply_auto_classify === undefined || skip_wmotherreply_auto_classify === undefined) {
            try {
                const attrRes = await this.doGetUserAttr([MailSettingKeys.skipWmreplyAutoClassify, MailSettingKeys.skipWmotherreplyAutoClassify]);
                const res = {
                    skip_wmreply_auto_classify: !!attrRes.skip_wmreply_auto_classify || false,
                    skip_wmotherreply_auto_classify: !!attrRes.skip_wmotherreply_auto_classify || false,
                };
                this.action.mailConf = Object.assign(Object.assign({}, this.action.mailConf), res);
                return res;
            }
            catch (error) {
                throw new Error('请求营销回复自动分类配置失败');
            }
        }
        return {
            skip_wmreply_auto_classify: !!skip_wmreply_auto_classify,
            skip_wmotherreply_auto_classify: !!skip_wmotherreply_auto_classify,
        };
    }
    doSetUserAttr(attrs, _account) {
        return this.httpApi
            .post(this.buildUrl('setAttr', undefined, _account), {
            attrs,
        }, Object.assign({ contentType: 'json', useCacheResultPeriod: 600000, cachePolicy: 'refresh' }, { _account }))
            .then(this.unpackData.bind(this))
            .then((res) => {
            console.log('doSetUserAttr', res);
            if (res.code === MailConfApiImpl.sOk) {
                const currentAction = this.systemApi.getActions({
                    actions: this.action,
                    subActions: this.subAccountAction,
                    _account,
                }).val;
                currentAction && (currentAction.mailConf = Object.assign(Object.assign({}, currentAction.mailConf), attrs));
                return true;
            }
            return false;
        })
            .catch(reason => {
            console.warn(reason);
            return false;
        });
    }
    getMailLimit(params) {
        const { _account } = params || {};
        const user = this.systemApi.getCurrentUser(_account);
        if ((user === null || user === void 0 ? void 0 : user.domain) && CLOUD_ATTACHMENT_50M_DOMAINS.includes(user.domain)) {
            const m50 = 50 * 1024 * 1024;
            return {
                upload_size: m50,
                upload_total_size: m50,
                smtp_max_send_mail_size: m50,
            };
        }
        const curVersionId = this.productAuthApi.doGetProductVersionId();
        const mailLimit = curVersionId === 'free'
            ? {
                upload_size: free_upload_size_local,
                upload_total_size: free_upload_total_size_local,
                smtp_max_send_mail_size: free_smtp_max_send_mail_size_local,
            }
            : {
                upload_size: upload_size_local,
                upload_total_size: upload_total_size_local,
                smtp_max_send_mail_size: smtp_max_send_mail_size_local,
            };
        try {
            const currentAction = this.systemApi.getActions({
                actions: this.action,
                subActions: this.subAccountAction,
                _account,
            }).val;
            if (currentAction) {
                const { mailConf = {} } = currentAction;
                const nUploadSizeStr = MailSettingKeys.nUploadSize;
                const nSmtpMaxSendMailSizeStr = MailSettingKeys.nSmtpMaxSendMailSize;
                if (mailConf[nUploadSizeStr]) {
                    mailLimit.upload_size = Number(mailConf[nUploadSizeStr]) * 1024;
                    mailLimit.upload_total_size = Number(mailConf[nUploadSizeStr]) * 1024;
                }
                if (mailConf[nSmtpMaxSendMailSizeStr]) {
                    mailLimit.smtp_max_send_mail_size = Number(mailConf[nSmtpMaxSendMailSizeStr]) * 1024;
                }
            }
        }
        catch (error) {
            console.error('get upload_size error', error);
        }
        return mailLimit;
    }
    doUpdatePOPAccounts(items, _account) {
        return this.httpApi
            .post(this.buildUrl('updatePOPAccounts'), {
            items,
        }, {
            contentType: 'json',
            useCacheResultPeriod: 600000,
            cachePolicy: 'refresh',
            _account,
        })
            .then(this.unpackData.bind(this))
            .then((res) => {
            console.log('doUpdatePOPAccounts', res);
            if (res.code === MailConfApiImpl.sOk) {
                return true;
            }
            return false;
        })
            .catch(reason => {
            console.warn(reason);
            return false;
        });
    }
    isSubAccount(_account) {
        if (!_account || !_account.length)
            return false;
        const subAccountEmailId = this.storeApi.getEmailIdByEmail(_account);
        return !!subAccountEmailId;
    }
    getReadMailPackUrl(mail, atts, filename) {
        var _a, _b;
        const isCorpMail = this.systemApi.getIsCorpMailMode();
        const urlKey = isCorpMail ? 'corpMailGetPackData' : 'readPack';
        let url = this.systemApi.getUrl(urlKey);
        let password = '';
        const _token = ((_a = this.accountTokens.find((token) => token.account === mail._account)) === null || _a === void 0 ? void 0 : _a.token) || '';
        const sid = this.getSid(mail._account);
        const partIds = atts.map(at => at.id).filter(e => e);
        const mailId = mail.entry.id;
        const targetActions = this.systemApi.getActions({
            actions: this.mailApi.actions,
            subActions: this.subAccountAction,
            _account: mail._account,
        }).val;
        const cacheContent = (_b = targetActions === null || targetActions === void 0 ? void 0 : targetActions.decryptedMailsCache) === null || _b === void 0 ? void 0 : _b.get(mail.entry.id);
        if (cacheContent) {
            password = cacheContent.encpwd;
        }
        let pUrl = '';
        if (partIds && partIds.length > 0) {
            if (this.isSubAccount(mail._account) && !this.systemApi.getIsCorpMailMode() && !this.systemApi.isElectron()) {
                url = this.systemApi.getUrl('readPackProxy');
                pUrl += `${url}?mid=${mailId}&sid=${sid}&part=${partIds.join('&part=')}&_token=${_token}`;
            }
            else {
                pUrl += `${url}?mid=${mailId}&sid=${sid}&part=${partIds.join('&part=')}`;
            }
        }
        if (filename) {
            pUrl += `&filename=${encodeURIComponent(filename)}`;
        }
        if (password) {
            pUrl += `&password=${password}`;
        }
        console.log('getReadMailPackUrl', pUrl);
        return pUrl;
    }
    getFjFileUrl(params) {
        const { partIds, pack = true, filename } = params;
        const user = this.systemApi.getCurrentUser();
        if (!user) {
            return '';
        }
        const { sessionId: sid } = user;
        let pUrl = `${this.systemApi.getUrl('getFjFile')}?sid=${sid}&mode=download&pack=${String(pack)}&part=${partIds.join('&part=')}`;
        if (filename)
            pUrl += `&filename=${encodeURIComponent(filename)}`;
        console.log('getFjFileUrl', pUrl);
        return pUrl;
    }
    getEntSignature(useCache, _account) {
        const currentAction = this.systemApi.getActions({
            actions: this.action,
            subActions: this.subAccountAction,
            _account,
        }).val;
        if (useCache && currentAction && currentAction.entSignature) {
            return Promise.resolve(currentAction.entSignature);
        }
        const entUrl = this.systemApi.getAccountUrl('entSignatureForMail', _account);
        const sid = this.getSid(_account);
        if (!sid) {
            return Promise.reject(new Error('未登录？'));
        }
        const requestWith = (cachePolicy) => this.httpApi
            .get(entUrl, { sid }, Object.assign({ useCacheResultPeriod: 600000, responseType: 'text', expectedResponseType: 'json', cachePolicy }, { _account }))
            .then(this.unpackData.bind(this))
            .then((res) => {
            if (res.msg === MailConfApiImpl.sOk || res.code === 200) {
                const data = res.data || res.result;
                const signature = {
                    content: data === null || data === void 0 ? void 0 : data.content,
                    enable: (data === null || data === void 0 ? void 0 : data.apply) === 1,
                    isDefault: (data === null || data === void 0 ? void 0 : data.position) === 1,
                    display: data === null || data === void 0 ? void 0 : data.display,
                    syncShowPerson: (data === null || data === void 0 ? void 0 : data.syncShowPerson) !== false,
                };
                currentAction.entSignature = signature;
                return signature;
            }
            console.warn('got enterprise signature fail:', res);
            return {
                content: '',
                enable: false,
                display: 0,
            };
        });
        const emptySignature = (reason) => {
            console.warn('got enterprise signature fail:', reason);
            return {
                content: '',
                enable: false,
                display: 0,
            };
        };
        if (!useCache) {
            return requestWith('refresh').catch(() => requestWith('useAndRefresh').catch(emptySignature));
        }
        return requestWith('useAndRefresh').catch(emptySignature);
    }
    getUserSignature(id) {
        if (!id) {
            return Promise.reject(new Error('no id set'));
        }
        const key = String(id);
        if (this.action.signatures && this.action.signatures.containsKey(key)) {
            return Promise.resolve(this.action.signatures.getByKey(key));
        }
        return this.listUserSignature(false).then(() => {
            if (this.action.signatures && this.action.signatures.containsKey(key)) {
                return this.action.signatures.getByKey(key);
            }
            return undefined;
        });
    }
    getRiskReminderStatus(type = 4, _account) {
        const url = this.systemApi.getUrl('getRiskReminderStatus');
        return this.httpApi
            .get(url, { type }, { _account })
            .then(res => { var _a, _b, _c; return ((_c = (_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.result) === null || _b === void 0 ? void 0 : _b.setting) === null || _c === void 0 ? void 0 : _c.status) || 0; })
            .catch(() => 0);
    }
    updateRiskReminderStatus(enable) {
        const status = enable ? 0 : 1;
        const param = {
            type: 4,
            status,
            mail_alert: status === null || status === void 0 ? void 0 : status.toString(),
            sms_alert: status === null || status === void 0 ? void 0 : status.toString(),
        };
        const url = this.systemApi.getUrl('updateRiskReminderStatus');
        return this.httpApi
            .post(url, param)
            .then(res => {
            var _a, _b;
            this.storeApi.putSync('riskReminderStatus', String(status));
            return (_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.result) === null || _b === void 0 ? void 0 : _b.suc;
        })
            .catch(() => false);
    }
    getLoginAlertSetting() {
        const url = this.systemApi.getUrl('getRiskReminderStatus');
        return this.httpApi
            .get(url, { type: 1 })
            .then(res => {
            var _a, _b, _c, _d, _e;
            const setting = (_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.result) === null || _b === void 0 ? void 0 : _b.setting;
            if (!setting)
                return null;
            return {
                status: (_c = setting.status) !== null && _c !== void 0 ? _c : 0,
                bindMobile: !!setting.bindMobile,
                mailAlert: (_d = setting.mailAlert) !== null && _d !== void 0 ? _d : 1,
                smsAlert: (_e = setting.smsAlert) !== null && _e !== void 0 ? _e : 1,
            };
        })
            .catch(() => null);
    }
    updateLoginAlertSetting(params) {
        const url = this.systemApi.getUrl('updateRiskReminderStatus');
        const param = {
            type: 1,
            status: params.status,
            mail_alert: String(params.mail_alert),
            sms_alert: String(params.sms_alert),
        };
        return this.httpApi
            .post(url, param)
            .then(res => { var _a, _b; return !!((_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.result) === null || _b === void 0 ? void 0 : _b.suc); })
            .catch(() => false);
    }
    getAntiSpamNotify() {
        const url = this.systemApi.getUrl('getAntiSpamNotify');
        return this.httpApi
            .get(url, {})
            .then(res => {
            var _a, _b;
            const rate = (_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.result) === null || _b === void 0 ? void 0 : _b.notify_rate;
            return rate !== undefined ? Number(rate) : 2;
        })
            .catch(() => 2);
    }
    updateAntiSpamNotify(notifyRate) {
        const url = this.systemApi.getUrl('updateAntiSpamNotify') + `?notify_rate=${notifyRate}`;
        return this.httpApi
            .get(url, {})
            .then(() => true)
            .catch(() => false);
    }
    createUserSignature(item) {
        const url = this.buildUrl('createSignature');
        item.name = item.name || 'auto-' + (new Date().getTime() % 10000000);
        item.isHtml = true;
        return this.httpApi
            .post(url, { items: [item], riskHitIntercept: true }, { contentType: 'json' })
            .then((res) => this.unpackData(res))
            .then((res) => {
            if (res.code === MailConfApiImpl.sOk) {
                item.id = res.var[0];
                this.action.signatures.add(item);
            }
            return {
                code: res.code,
                title: res.code === MailConfApiImpl.sOk ? res.var : res.message,
            };
        });
    }
    deleteUserSignature(ids) {
        if (!ids || (Array.isArray(ids) && ids.length === 0)) {
            return Promise.reject(new Error('参数错误'));
        }
        const url = this.buildUrl('deleteSignature');
        const data = Array.isArray(ids) ? { ids } : { ids: [ids] };
        return this.httpApi
            .post(url, data, {
            contentType: 'json',
        })
            .then(res => {
            const responseData = this.unpackData(res);
            if (responseData.code === MailConfApiImpl.sOk) {
                const items = Array.isArray(ids) ? ids.map(it => ({ id: Number(it) })) : [{ id: ids }];
                this.action.signatures.removeAll(items);
            }
            return {
                code: responseData.code,
                title: responseData.message,
            };
        });
    }
    getMailClassifyRule(_account, needSentRule = true) {
        const url = this.buildUrl('getMailClassifyRule', undefined, _account);
        return this.httpApi
            .post(url, { category: 'sirius_filter', needSentRule }, { contentType: 'json', _account })
            .then((res) => this.unpackData(res))
            .then((res) => (res === null || res === void 0 ? void 0 : res.var) || []);
    }
    async disableThirdAccountReverseSync(items, _account) {
        var _a, _b;
        const enableRule = items.some(item => !item.disabled);
        const user = this.systemApi.getCurrentUser(_account || '');
        if (!user) {
            return { success: false, message: '执行失败' };
        }
        const { isSubAccount } = user;
        const isThirdAccountAsMain = (!_account || _account === (((_a = this.systemApi.getCurrentUser(_account)) === null || _a === void 0 ? void 0 : _a.id) || '')) && ((_b = user.prop) === null || _b === void 0 ? void 0 : _b.authAccountType) !== '0';
        if (enableRule && (isSubAccount || isThirdAccountAsMain)) {
            const params = {
                bindEmail: user.agentEmail || user.id,
                bindThirdEmail: user.id,
                bindUserName: '__not_set_$no_change__',
                syncStetagy: 1,
                version: 1,
            };
            try {
                const updateRes = await this.mailApi.updateDisplayEmail(params);
                if (updateRes === 'success') {
                    return { success: true };
                }
                return { success: false, message: '执行失败' };
            }
            catch (error) {
                return { success: false, message: '执行失败' };
            }
        }
        else {
            return { success: true };
        }
    }
    async addMailClassifyRule(items, _account) {
        const disRes = await this.disableThirdAccountReverseSync(items, _account);
        const { success, message } = disRes;
        if (!success) {
            throw new Error(message || '执行失败');
        }
        const url = this.buildUrl('addMailClassifyRule', undefined, _account);
        return this.httpApi
            .post(url, { items, riskHitIntercept: true }, { contentType: 'json', _account })
            .then((res) => this.handleRiskHitInterrupt(res))
            .then((res) => this.unpackData(res))
            .then((res) => {
            var _a;
            let message = '规则保存成功！';
            const isSuc = res.code === 'S_OK';
            if (!isSuc) {
                message = '规则保存失败！请稍后重试！';
                if (res.exist && res.limit && res.exist >= res.limit) {
                    message = `规则保存失败，最多支持创建${res.limit}条！`;
                }
            }
            return {
                code: res.code,
                data: (_a = res.var) !== null && _a !== void 0 ? _a : [],
                title: message,
                success: isSuc,
            };
        });
    }
    async editMailClassifyRule(items, _account) {
        const disRes = await this.disableThirdAccountReverseSync(items, _account);
        const { success, message } = disRes;
        if (!success) {
            throw new Error(message || '执行失败');
        }
        const url = this.buildUrl('editMailClassifyRule', undefined, _account);
        return this.httpApi
            .post(url, { items, riskHitIntercept: true }, { contentType: 'json', _account })
            .then((res) => this.handleRiskHitInterrupt(res))
            .then((res) => this.unpackData(res))
            .then((res) => {
            let message = '规则保存成功！';
            const isSuc = res.code === 'S_OK';
            if (!isSuc) {
                message = '规则保存失败！请稍后重试！';
            }
            return {
                code: res.code,
                title: message,
                success: isSuc,
            };
        });
    }
    sortMailClassifyRule(id, value, _account) {
        const url = this.buildUrl('sortMailClassifyRule', undefined, _account);
        return this.httpApi
            .post(url, { id, value }, { contentType: 'json', _account })
            .then((res) => this.unpackData(res))
            .then((res) => ({
            code: res.code,
            title: res.message,
        }));
    }
    deleteMailClassifyRule(ids, _account) {
        const url = this.buildUrl('deleteMailClassifyRule', undefined, _account);
        return this.httpApi
            .post(url, { ids, riskHitIntercept: true }, { contentType: 'json', _account })
            .then((res) => this.handleRiskHitInterrupt(res))
            .then((res) => this.unpackData(res))
            .then((res) => ({
            code: res.code,
            title: res.message,
            success: res.code === 'S_OK',
        }));
    }
    effectHistoryMail(params1) {
        const { id: rule, ruleIds, fids, _account } = params1;
        const url = this.buildUrl('effectHistoryMail', undefined, _account);
        const params = ruleIds
            ? {
                ruleIds,
            }
            : { rule: `@${rule}` };
        if (fids)
            params.fids = fids;
        return this.httpApi
            .post(url, params, { contentType: 'json', _account })
            .then((res) => this.unpackData(res))
            .then((res) => {
            let message = '';
            if (res.code === 'FA_OVERFLOW') {
                message = '历史邮件暂未生效，系统繁忙，请稍后重试。';
            }
            else if (res.code === 'FA_DUPLICATED_TASK') {
                message = '请勿重复创建，当前有规则正在执行，请稍后手动重新执行该规则';
            }
            else if (res.code !== 'S_OK') {
                message = '历史邮件暂未生效，操作失败，请稍后重试。';
            }
            return {
                code: res.code,
                title: message,
                success: res.code === 'S_OK',
            };
        });
    }
    listUserSignature(onlyGetDefault, useCache) {
        if (useCache && this.action.signatures.size() > 0) {
            const all = this.action.signatures.getAll();
            return Promise.resolve(this.sortSig(all));
        }
        const url = this.buildUrl('getSignature');
        return this.httpApi
            .post(url, {
            onlyGetId: false,
            onlyGetDefault: !!onlyGetDefault,
        }, {
            contentType: 'json',
            useCacheResultPeriod: 600000,
            cachePolicy: useCache ? 'useDirect' : 'refresh',
        })
            .then(this.unpackData.bind(this))
            .then((res) => {
            if (res.code === MailConfApiImpl.sOk) {
                if (res.var && res.var.length > 0) {
                    this.storeSignature(this.sortSig(res.var));
                    return res.var;
                }
            }
            return undefined;
        })
            .catch(() => undefined);
    }
    sortSig(items) {
        return items.reverse();
    }
    markDefaultSignature(id) {
        return this.listUserSignature(false, false).then((res) => {
            if (res) {
                const lastItem = res.filter(it => it.isDefault).pop();
                const curItem = res.filter(it => it.id === id).pop();
                if (!curItem) {
                    return {
                        code: 'PARAM.ERR',
                        title: '参数错误，请查证后重试',
                        popupType: 'window',
                    };
                }
                curItem.isDefault = true;
                if (lastItem) {
                    lastItem.isDefault = false;
                }
                return this.updateUserSignature(lastItem ? [lastItem, curItem] : curItem);
            }
            return {
                code: 'SERVER.ERR',
                title: '服务器错误，请稍后再次尝试',
                popupType: 'window',
            };
        });
    }
    updateUserSignature(items) {
        const url = this.buildUrl('updateSignature');
        const data = Array.isArray(items) ? { items } : { items: [items] };
        data.items.forEach(it => {
            it.isHtml = true;
        });
        return this.httpApi.post(url, Object.assign(Object.assign({}, data), { riskHitIntercept: true }), { contentType: 'json' }).then(res => {
            const data = this.unpackData(res);
            if (data.code === MailConfApiImpl.sOk) {
                if (Array.isArray(items)) {
                    this.action.signatures.addAll(items, true);
                }
                else {
                    this.action.signatures.update(items);
                }
            }
            return {
                code: data.code,
                title: data.message,
            };
        });
    }
    setDefaultSender(email) {
        const key = MailSettingKeys.nDefaultSendingAccount;
        return this.doSetUserAttr({
            [key]: email,
        });
    }
    setMailSenderName(name, _account) {
        const key = MailSettingKeys.nSenderName;
        return this.doSetUserAttr({
            [key]: name,
        }, _account);
    }
    getSid(_account) {
        const currentUser = this.systemApi.getCurrentUser(_account);
        return (currentUser === null || currentUser === void 0 ? void 0 : currentUser.sessionId) || '';
    }
    storeSignature(res) {
        if (res && res.length > 0) {
            this.action.signatures.addAll(res, true);
        }
    }
    getWebMailHost(hostOnly, _account) {
        const currentNode = this.systemApi.getCurrentNode(_account);
        return hostOnly ? MailConfApiImpl.webMailUrlMap[currentNode + 'Host'] : MailConfApiImpl.webMailUrlMap[currentNode];
    }
    getNewWebMailMainUrl() {
        const inWebMail = this.systemApi.inWebMail();
        if (inWebMail) {
            return `${this.getNewWebMailHost()}/js6/main.jsp`;
        }
        return this.getWebMailHost();
    }
    getNewWebMailHost(payload) {
        if (typeof window !== 'undefined' && !process.env.BUILD_ISELECTRON) {
            if (payload && payload.normal) {
                const { location } = window;
                return `${location.protocol}//${location.host}`;
            }
            const isWebmail = this.systemApi.inWebMail();
            if (isWebmail) {
                const { location } = window;
                return `${location.protocol}//${location.host}`;
            }
            this.getWebMailHost(true);
        }
        return this.getWebMailHost(true);
    }
    getRedirectHostForWebSetting(targetUrl) {
        if (targetUrl && /^https?:\/\//i.test(targetUrl)) {
            try {
                const { protocol, host } = new URL(targetUrl);
                return `${protocol}//${host}`;
            }
            catch (e) {
                console.warn('[mailConf] invalid redirect target url:', targetUrl, e);
            }
        }
        return this.getNewWebMailHost();
    }
    async getWebSettingUrlInLocal(name, urlType) {
        const currentUser = this.systemApi.getCurrentUser();
        if (!currentUser) {
            return '';
        }
        const cookies = await this.systemApi.doGetCookies(true);
        const { QIYE_TOKEN, QIYE_SESS, Coremail } = cookies;
        const redirectHost = urlType.url ? this.getRedirectHostForWebSetting(urlType.url) : this.getNewWebMailHost();
        const host = redirectHost + '/redirect.jsp';
        const tkValue = QIYE_TOKEN ? `?tk=${escape(QIYE_TOKEN)}` : '?tk=';
        const sValue = QIYE_SESS ? `&s=${escape(QIYE_SESS)}` : '';
        const cValue = Coremail ? `&c=${escape(Coremail)}` : '';
        const uValue = `&u=${currentUser.id}`;
        const hl = inWindow() && window.systemLang === 'en' ? 'en_US' : 'zh_CN';
        let lValue = '';
        if (urlType.url) {
            lValue = '&l=' + escape(urlType.url);
        }
        else if (urlType.params) {
            lValue = '&l=' + escape(`${this.getNewWebMailMainUrl()}?sid=${currentUser.sessionId}&hl=${hl}#module=${name}${escape('|' + JSON.stringify(urlType.params))}`);
        }
        return host + tkValue + sValue + cValue + uValue + lValue;
    }
    async getWebSettingUrl(name) {
        const url = this.systemApi.getUrl('genMailOnlineJumpURL');
        const hl = inWindow() && window.systemLang === 'en' ? 'en_US' : 'ZH';
        try {
            const data = await this.httpApi.get(url, {
                sid: this.getSid(),
                module: name,
                hl,
            });
            if (data.data && data.data.success) {
                return data.data.data.url;
            }
        }
        catch (e) {
            console.warn(e);
        }
        return undefined;
    }
    async getSettingUrlCommon(params) {
        const { name, inLocal, urlType, isCorpMail } = params;
        const url = this.systemApi.isElectron()
            ? this.getSettingUrl(name, urlType)
            :
                isCorpMail
                    ? this.getCorpSettingUrl(name, urlType.params)
                    : inLocal
                        ? await this.getWebSettingUrlInLocal(name, urlType)
                        : await this.getWebSettingUrl(name);
        return url;
    }
    getMailTabGuide(key) {
        return this.getLocalSettingValue(key);
    }
    setMailTabGuide(key, val) {
        this.putLocalSettingValue(val, key);
    }
    getCorpSettingUrl(name, params) {
        const isCorpMail = this.systemApi.getIsCorpMailMode();
        if (isCorpMail) {
            const webUrl = corpMailUtils.getWebUrlByFeatureName((params === null || params === void 0 ? void 0 : params.subModName) ? params.subModName : name);
            if (webUrl) {
                return webUrl;
            }
        }
        return '';
    }
    getSettingUrl(name, urlType) {
        const isCorpMail = this.systemApi.getIsCorpMailMode();
        if (isCorpMail) {
            return this.getCorpSettingUrl(name, urlType === null || urlType === void 0 ? void 0 : urlType.params);
        }
        if (urlType === null || urlType === void 0 ? void 0 : urlType.url) {
            return urlType.url;
        }
        const currentUser = this.systemApi.getCurrentUser();
        const hl = inWindow() && window.systemLang === 'en' ? 'en_US' : 'zh_CN';
        if (currentUser) {
            let paramsValue = '';
            if (urlType === null || urlType === void 0 ? void 0 : urlType.params) {
                paramsValue = escape('|' + JSON.stringify(urlType === null || urlType === void 0 ? void 0 : urlType.params));
            }
            return this.getNewWebMailMainUrl() + '?sid=' + currentUser.sessionId + `&hl=${hl}#module=${name}${paramsValue}`;
        }
        return '';
    }
    async doGetMailAliasAccountList(noMain) {
        const url = this.buildUrl('aliasAccount');
        const res = await this.httpApi.get(url, {}, {
            cachePolicy: 'useAndRefresh',
        });
        const currentUser = this.systemApi.getCurrentUser();
        if (!currentUser || !currentUser.sessionId) {
            return [];
        }
        const defaultSendingAccount = await this.getDefaultSendingAccount();
        if (!currentUser.accountName) {
            const nad = this.systemApi.handleAccountAndDomain(currentUser.id);
            currentUser.accountName = nad.account;
        }
        let rettt = [];
        if (!noMain) {
            rettt.push({
                fid: 1,
                color: 1,
                name: currentUser.nickName || currentUser.accountName,
                id: currentUser.id,
                domain: currentUser.domain,
                isDefault: currentUser.id === defaultSendingAccount,
            });
        }
        if (res.data && res.data.code === MailConfApiImpl.sOk) {
            const result = res.data;
            if (result && result.var && result.var.length > 0) {
                const ret = result.var[0];
                const mailAliasAccountModels = ret.aliases;
                mailAliasAccountModels.forEach(it => {
                    if (it.id === defaultSendingAccount) {
                        it.isDefault = true;
                    }
                    it.domain = currentUser.domain;
                    rettt.push(it);
                });
            }
        }
        else {
        }
        const strings = rettt.map(info => info.id);
        if (!currentUser.prop ||
            !('accountAlias' in currentUser.prop) ||
            !currentUser.prop.accountAlias ||
            !util.compareArray(strings, currentUser.prop.accountAlias, false)) {
            this.storeApi.setUserProp('accountAlias', strings, true);
        }
        rettt = rettt.sort((a, b) => {
            if (a.isDefault) {
                return -1;
            }
            return b.isDefault ? 1 : 0;
        });
        return rettt;
    }
    async requestTaglist(_account) {
        var _a, _b, _c;
        const key = 'getTaglist';
        const url = this.buildUrl(key, undefined, _account);
        const requestData = {
            stats: true,
            threads: true,
            threadSupportTag: true,
        };
        const requestConfig = {
            cachePolicy: this.action.tagsUpdated ? 'useAndRefresh' : 'refresh',
            _account,
        };
        const isCorpMail = this.systemApi.getIsCorpMailMode();
        const ret = isCorpMail
            ? await this.httpApi.post(url, requestData, Object.assign(Object.assign({}, requestConfig), { contentType: 'json', _account }))
            : await this.httpApi.get(url, requestData, requestConfig);
        if (isCorpMail) {
            corpMailUtils.corpMailTransformResponse(ret);
        }
        if (ret.status !== 200 || ((_a = ret.data) === null || _a === void 0 ? void 0 : _a.code) !== 'S_OK') {
            return Promise.reject(new Error(((_b = ret.data) === null || _b === void 0 ? void 0 : _b.message) || '请求错误'));
        }
        this.tagList = ret.data.var;
        const tagList = ret.data.var;
        if (process.env.BUILD_ISEDM || ((_c = this.systemApi.doGetProductInfo()) === null || _c === void 0 ? void 0 : _c.navigateVersion)) {
            if (!tagList.find(item => item[0] === '__delivery__')) {
                tagList.unshift(['__delivery__', { color: 3, show: 1 }, 0, 0, 0, 0, 0, 0]);
            }
            if (!tagList.find(item => item[0] === '__deliveryrecord__')) {
                tagList.unshift(['__deliveryrecord__', { color: 3, show: 1 }, 0, 0, 0, 0, 0, 0]);
            }
        }
        tagList.forEach((item) => {
            var _a, _b, _c;
            const strokeColor = ((_a = reDefinedColorList.find(innerItem => { var _a; return innerItem.nums.includes((_a = item[1]) === null || _a === void 0 ? void 0 : _a.color); })) === null || _a === void 0 ? void 0 : _a.color) || '#6BA9FF';
            const newBgColor = ((_b = reDefinedColorListNew.find(innerItem => { var _a; return innerItem.nums.includes((_a = item[1]) === null || _a === void 0 ? void 0 : _a.color); })) === null || _b === void 0 ? void 0 : _b.color) || '#6BA9FF';
            const fontColor = ((_c = reDefinedColorListNew.find(innerItem => { var _a; return innerItem.nums.includes((_a = item[1]) === null || _a === void 0 ? void 0 : _a.color); })) === null || _c === void 0 ? void 0 : _c.fontColor) || '#fff';
            this.tagNameMap[item[0]] = strokeColor;
            this.tagBgMap[item[0]] = newBgColor;
            this.tagNameFontColorMap[item[0]] = fontColor;
        });
        this.action.tagsUpdated = false;
        return Promise.resolve(tagList);
    }
    async updateMessageTags(params, _account) {
        var _a, _b;
        const key = 'updateMessageTags';
        const url = this.buildUrl(key, undefined, _account);
        const ret = await this.httpApi.post(url, Object.assign({}, params), {
            contentType: 'json',
            _account,
        });
        if (ret.status !== 200 || ((_a = ret.data) === null || _a === void 0 ? void 0 : _a.code) !== 'S_OK') {
            return Promise.reject(new Error(((_b = ret.data) === null || _b === void 0 ? void 0 : _b.message) || '操作失败'));
        }
        return Promise.resolve('');
    }
    getTaglist() {
        return this.tagList;
    }
    getTagColor(name, getNewColor) {
        if (getNewColor) {
            return this.tagBgMap[name];
        }
        return this.tagNameMap[name];
    }
    getTagFontColor(name) {
        return this.tagNameFontColorMap[name];
    }
    async manageTag(type, params, alias, _account) {
        var _a, _b, _c, _d;
        const key = 'manageTag';
        const url = this.buildUrl(key, undefined, _account);
        this.action.tagsUpdated = true;
        const EXIST_ERROR_MSG = '已存在同名标签（不区分英文大小写）';
        if (['add'].includes(type) && this.tagList.map(item => (item[0] || '').toLowerCase()).includes(alias.toLowerCase())) {
            return Promise.reject(new Error(EXIST_ERROR_MSG));
        }
        const ret = await this.httpApi.post(url, {
            [type]: params,
        }, {
            contentType: 'json',
            _account,
            noEnqueue: true,
        });
        const isCorpMail = this.systemApi.getIsCorpMailMode();
        if (isCorpMail) {
            corpMailUtils.corpMailTransformResponse(ret);
        }
        if (ret.status !== 200 || ((_a = ret.data) === null || _a === void 0 ? void 0 : _a.code) !== 'S_OK') {
            const message = ((_b = ret.data) === null || _b === void 0 ? void 0 : _b.message) ? (_c = ret.data) === null || _c === void 0 ? void 0 : _c.message : ((_d = ret.data) === null || _d === void 0 ? void 0 : _d.code) === 'FA_NAME_EXISTS' ? EXIST_ERROR_MSG : '操作失败';
            return Promise.reject(new Error(message));
        }
        this.action.tagsUpdated = true;
        setTimeout(() => {
            this.requestTaglist(_account);
            const newParams = params.map(v => {
                if (typeof v === 'string') {
                    return {
                        tag: v,
                        alias: '',
                    };
                }
                return {
                    tag: v[0],
                    alias: v[1].alias || '',
                };
            });
            this.mailApi.refreshDbMailsByTag(newParams, type, _account).then(() => {
                storeOps.mail.updateMailTag({
                    params,
                    type,
                    _account,
                });
                if (this.systemApi.isElectron()) {
                    this.eventApi.sendSysEvent({
                        eventName: 'mailStoreRefresh',
                        eventStrData: 'mailTag',
                        eventData: {
                            params,
                            type,
                        },
                        _account,
                    });
                }
            });
        }, 500);
        return Promise.resolve('');
    }
    async getReplySetting() {
        const key = MailSettingKeys.nReplay;
        const res = await this.doGetUserAttr([key]);
        return res[key];
    }
    setMailRealListPageSize(val) {
        try {
            this.storeApi.putSync(MailSettingKeys.nMailRealListPageSize, val.toString());
        }
        catch (ex) {
            console.error('setMailRealListPageSize-catch', ex);
        }
    }
    getMailRealListPageSize() {
        const deault_size = 20;
        try {
            const val = this.storeApi.getSync(MailSettingKeys.nMailRealListPageSize);
            if (val && val.suc && val.data) {
                return Number.parseInt(val.data, 10);
            }
            return deault_size;
        }
        catch (ex) {
            return deault_size;
        }
    }
    getIsUseRealListSync() {
        try {
            if (typeof MailConfApiImpl.isUseRealList === 'boolean') {
                return MailConfApiImpl.isUseRealList;
            }
            const val = this.storeApi.getSync(MailSettingKeys.nIsUseReaList, this.getUseRealListStoreConfig());
            if (val && val.suc && val.data) {
                const res = val.data === 'true';
                MailConfApiImpl.isUseRealList = res;
                return res;
            }
            return false;
        }
        catch (ex) {
            return false;
        }
    }
    getUseRealListStoreConfig() {
        return process.env.BUILD_ISLINGXI && process.env.BUILD_ISWEB && config('profile') && config('profile').startsWith('webmail')
            ? globalStoreConfig
            : undefined;
    }
    async setIsUseRealList(val) {
        try {
            this.putLocalSettingValue(val, MailSettingKeys.nIsUseReaList, undefined, this.getUseRealListStoreConfig());
            MailConfApiImpl.isUseRealList = val;
            this.setMailConfig();
            return true;
        }
        catch (ex) {
            console.error('setIsUseRealList error', ex);
            return false;
        }
    }
    async updateShouldAutoReadMail() {
        try {
            const currentUser = this.systemApi.getCurrentUser();
            if (!currentUser)
                return;
            const serverVals = await this.systemApi.getUserConfig([SHOULD_AUTO_READMAILSERVERKEY]);
            if (!serverVals || !serverVals.length) {
                return;
            }
            const shouldAutoReadMailItem = serverVals.filter(item => item.field === SHOULD_AUTO_READMAILSERVERKEY);
            if (shouldAutoReadMailItem && shouldAutoReadMailItem[0]) {
                const shouldAutoReadMail = shouldAutoReadMailItem[0].value !== 'false';
                await this.storeApi.put(SHOULD_AUTO_READMAILKEY, shouldAutoReadMail ? 'true' : 'false');
                this.action.shouldAutoReadMail = shouldAutoReadMail;
            }
        }
        catch (ex) {
            console.error('getShouldAutoReadMail-catch', ex);
        }
    }
    getShouldAutoReadMailSync() {
        try {
            return this.action.shouldAutoReadMail;
        }
        catch (ex) {
            return true;
        }
    }
    async setShouldAutoReadMail(val) {
        try {
            try {
                await this.storeApi.put(SHOULD_AUTO_READMAILKEY, val.toString());
            }
            catch (ex) {
                console.error('put-catch', ex);
            }
            this.action.shouldAutoReadMail = val;
            const res = await this.systemApi.setUserConfig([
                {
                    field: SHOULD_AUTO_READMAILSERVERKEY,
                    value: val.toString(),
                },
            ]);
            return res;
        }
        catch (ex) {
            console.error('setShouldAutoReadMail-catch', ex);
            return false;
        }
    }
    getTokenBySubAccount(subAccount) {
        if (!subAccount || !subAccount.length)
            return '';
        if (!this.accountTokens || !this.accountTokens.length)
            return '';
        const subAccountId = this.accountApi.getEmailIdByEmail(subAccount);
        if (!subAccountId)
            return '';
        const accountTokenInfo = this.accountTokens.filter(item => item.account === subAccountId);
        if (accountTokenInfo && accountTokenInfo.length) {
            return accountTokenInfo[0].token;
        }
        return '';
    }
    getMailLimitFromServer() {
        const url = this.systemApi.getUrl('getMailLimit');
        return this.httpApi
            .post(url, {})
            .then(res => {
            var _a, _b;
            const { success, data } = res.data;
            if (success) {
                const key1 = MailSettingKeys.nNormalDayLimit;
                const key2 = MailSettingKeys.nThirdDayLimit;
                const normalDayLimit = ((_a = data === null || data === void 0 ? void 0 : data.normalDayLimit) === null || _a === void 0 ? void 0 : _a.dayLimit) || 60;
                const thirdDayLimit = ((_b = data === null || data === void 0 ? void 0 : data.thirdDayLimit) === null || _b === void 0 ? void 0 : _b.dayLimit) || 60;
                this.putLocalSettingValue(normalDayLimit, key1);
                this.putLocalSettingValue(thirdDayLimit, key2);
            }
        })
            .catch(e => {
            console.log('getMailLimitFromServer error:', e);
        });
    }
    getMailDayLimit() {
        const key1 = MailSettingKeys.nNormalDayLimit;
        const key2 = MailSettingKeys.nThirdDayLimit;
        const normalDayLimit = +this.getLocalSettingValue(key1, '60');
        const thirdDayLimit = +this.getLocalSettingValue(key2, '60');
        return { normalDayLimit, thirdDayLimit };
    }
    async getAccCusSetting() {
        var _a;
        const url = this.systemApi.getUrl('getAccCusSetting');
        try {
            const data = await this.httpApi.get(url, {});
            return ((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.result) || null;
        }
        catch (e) {
            console.error(e);
        }
    }
    async batchCheckTrOrgInfo(ids) {
        var _a;
        const url = this.systemApi.getUrl('batchCheckTrOrgInfo');
        try {
            const data = await this.httpApi.get(url, {
                eids: ids,
            });
            return ((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.result) || null;
        }
        catch (e) {
            console.error(e);
        }
    }
    async getTrOrgCertInfo(params) {
        var _a;
        const { eid, domain, account_name } = params;
        const url = this.systemApi.getUrl('getTrOrgCertInfo');
        try {
            const data = await this.httpApi.get(url, {
                eid,
                domain,
                account_name,
            });
            return ((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.result) || null;
        }
        catch (e) {
            console.error(e);
        }
    }
    async updateAccCusSetting(params) {
        const url = this.systemApi.getUrl('updateAccCusSetting');
        try {
            const data = await this.httpApi.post(url, Object.assign({}, params));
            return data;
        }
        catch (e) {
            console.error(e);
        }
    }
    reportAttachPreview(params) {
        var _a;
        const mainUser = this.systemApi.getCurrentUser();
        if (params._account && mainUser && params._account !== mainUser.id) {
            return;
        }
        const sid = (_a = this.systemApi.getCurrentUser(params._account)) === null || _a === void 0 ? void 0 : _a.sessionId;
        if (!sid)
            return;
        const url = this.httpApi.buildUrl(this.systemApi.getUrl('mailOperation'), {
            func: 'log:report',
            sid,
            action: 'attach_preview',
            filename: params.filename || '',
            mid: params.mid || '',
        });
        this.httpApi.get(url, {}, { noErrorMsgEmit: true }).catch(() => { });
    }
}
MailConfApiImpl.sOk = 'S_OK';
MailConfApiImpl.comNotExist = config('notExistUrl');
MailConfApiImpl.webMailUrlMap = {
    hz: config('webMailHZUrl'),
    hzHost: config('webMailHZHost'),
    bj: config('webMailBJUrl'),
    bjHost: config('webMailBJHost'),
};
MailConfApiImpl.nReplayEnMap = {
    original: 'Original',
    fw: 'Forwarded message',
    from: 'From',
    date: 'Date',
    to: 'To',
    cc: 'Cc',
    subject: 'Subject',
};
MailConfApiImpl.nReplayChnMap = {
    original: '原始邮件',
    fw: '转发邮件信息',
    from: '发件人',
    date: '发送日期',
    to: '收件人',
    cc: '抄送',
    subject: '主题',
};
MailConfApiImpl.host = config('host');
MailConfApiImpl.contextPath = config('contextPath');
MailConfApiImpl.isUseRealList = null;
const mailConfApi = new MailConfApiImpl();
api.registerLogicalApi(mailConfApi);
export default mailConfApi;
